"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _framerMotion = require("framer-motion");
var _excluded = ["active", "tabKey", "disableTransition", "children", "title"];
var DataTab = function DataTab(props) {
  var active = props.active,
    tabKey = props.tabKey,
    disableTransition = props.disableTransition,
    children = props.children,
    title = props.title,
    remainingProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (disableTransition) {
    return /*#__PURE__*/_react["default"].createElement("div", null, active && children);
  }
  return active && /*#__PURE__*/_react["default"].createElement(_framerMotion.motion.div, (0, _extends2["default"])({}, remainingProps, {
    key: tabKey,
    initial: {
      x: 0,
      y: 0,
      opacity: 0
    },
    animate: {
      x: 0,
      y: 0,
      opacity: 1
    },
    exit: {
      x: 0,
      y: 0,
      opacity: 0
    },
    transition: {
      duration: 0.1
    }
    // TODO: added "fade in" for backwards compatibility for service tests
    // To be removed for next major version
    ,
    className: "fade in"
  }), children);
};
DataTab.defaultProps = {
  active: false,
  disableTransition: false,
  className: ''
};
DataTab.propTypes = {
  // Props are injected from the wrapping DataTabs component
  disableTransition: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  tabKey: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string])
};
var _default = DataTab;
exports["default"] = _default;